import { Reducer } from 'redux'

import { BiometriaTypes, BiometriaState, DEFAULT_BIOMETRIC_ACTIVE } from './types'

const INITIAL_STATE: BiometriaState = {
  unicoId: '',
  base64: '',
  encrypted: '',
  retryLiveness: false,
  error: false,
  loadingLiveness: false,
  lastLiveness: {
    unicoId: '',
    proposta: '',
    status: '',
    etapa: '',
    dataCriacao: '',
    score: 0,
  },
  biometricToken: '',
  loadingBiometricsValidate: false,
  biometricActive: DEFAULT_BIOMETRIC_ACTIVE,
  loadingGenerateIdUnicoLink: false,
  seed: '',
  seedError: false,
  seedLoading: false,
}

const reducer: Reducer<BiometriaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BiometriaTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case BiometriaTypes.SET_LAST_LIVENESS:
      return { ...state, lastLiveness: action.payload }
    case BiometriaTypes.SET_BIOMETRIC_TOKEN:
      return { ...state, biometricToken: action.payload }
    case BiometriaTypes.SET_LOADING_BIOMETRICS_VALIDATE:
      return { ...state, loadingBiometricsValidate: action.payload }
    case BiometriaTypes.SET_BIOMETRIC_ACTIVE:
      return { ...state, biometricActive: action.payload }
    case BiometriaTypes.SET_LOADING_GENERATE_ID_UNICO_LINK:
      return { ...state, loadingGenerateIdUnicoLink: action.payload }
    case BiometriaTypes.SEED_REQUEST:
      return { ...state, seedError: false, seedLoading: true }
    case BiometriaTypes.SEED_SUCCESS:
      return { ...state, seedError: false, seedLoading: false, seed: action.payload }
    case BiometriaTypes.SEED_ERROR:
      return { ...state, seedError: true, seedLoading: false }

    case BiometriaTypes.RESET:
      return { ...INITIAL_STATE }
    default:
      return state
  }
}

export default reducer
